/* 電話番号 */
import React, { useState, useCallback } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';

interface Props {
  label: string;
  need?: boolean;
  value: string[];
  message?: string;
  help_msg?: string;
  disabled: boolean;
  readonly?: boolean;
}

const TelInput: React.FC<Props> = ({ label, need, value, message, help_msg, disabled, readonly }) => {
  const [tel01, setTel01] = useState(value[0] ? value[0] : '');
  const [tel02, setTel02] = useState(value[1] ? value[1] : '');
  const [tel03, setTel03] = useState(value[2] ? value[2] : '');

  const handleChangeTel01 = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setTel01(event.target.value);
  }, []);
  const handleChangeTel02 = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setTel02(event.target.value);
  }, []);
  const handleChangeTel03 = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setTel03(event.target.value);
  }, []);

  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      content={
        <>
          <Row>
            <Col xs={3} className="pr-0">
              <Form.Control
                type="NUMBER"
                onChange={handleChangeTel01}
                defaultValue={tel01}
                disabled={disabled || readonly}
              />
            </Col>
            <Col xs={1} className="d-flex align-items-center justify-content-center">
              －
            </Col>
            <Col xs={3} className="p-0">
              <Form.Control
                type="NUMBER"
                onChange={handleChangeTel02}
                defaultValue={tel02}
                disabled={disabled || readonly}
              />
            </Col>
            <Col xs={1} className="d-flex align-items-center justify-content-center">
              －
            </Col>
            <Col xs={3} className="p-0">
              <Form.Control
                type="NUMBER"
                onChange={handleChangeTel03}
                defaultValue={tel03}
                disabled={disabled || readonly}
              />
            </Col>
          </Row>
          <Messages help_msg={help_msg} valid_msg={message} />
        </>
      }
    />
  );
};

export default TelInput;
